export class AccessTokenRefreshError extends Error {
  constructor() {
    super('Token can not be refreshed.');

    // Changing prototype for extending default class is recommended by TS
    // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, AccessTokenRefreshError.prototype);

    this.name = 'AccessTokenRefreshError';
  }
}
